(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hw-header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('.hw-header__mobile a');
    if (link) link.closest('details').open = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-shop"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hw-shop-card'))customElements.define('hw-shop-card',class extends HTMLElement{connectedCallback(){this.abort=new AbortController();this.addEventListener('click',e=>{const b=e.target.closest('button[data-color]');if(!b)return;this.querySelectorAll('button[data-color]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));const img=this.querySelector('.hw-shop__photo img');img.removeAttribute('srcset');img.src=b.dataset.image;img.alt='Alpenglück in '+b.dataset.color;this.querySelector('[data-color-name]').textContent='Farbe: '+b.dataset.color;this.querySelectorAll('[data-product-link]').forEach(x=>x.href=b.dataset.url);if(!matchMedia('(prefers-reduced-motion: reduce)').matches)img.animate([{transform:'scale(.92)',opacity:.6},{transform:'scale(1)',opacity:1}],{duration:500,easing:'ease-out'});},{signal:this.abort.signal});}disconnectedCallback(){this.abort?.abort();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
